const daProps = plan => {
  return {
    "da-label": `${`${plan?.basePlanName}`}`.toLowerCase().replace(/\s/g, ""),
    "da-category": "quiz",
    "da-action": "continue-pricing"
  };
};

export default daProps;
